var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 12L5.25024 8.25L6.30024 7.1625L8.25024 9.1125V3H9.75024V9.1125L11.7002 7.1625L12.7502 8.25L9.00024 12ZM4.50024 15C4.08774 15 3.73462 14.8531 3.44087 14.5594C3.14712 14.2656 3.00024 13.9125 3.00024 13.5V11.25H4.50024V13.5H13.5002V11.25H15.0002V13.5C15.0002 13.9125 14.8534 14.2656 14.5596 14.5594C14.2659 14.8531 13.9127 15 13.5002 15H4.50024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.602f5c0e8cec9f263d1f9101919ffb11.svg";
export { ForwardRef as ReactComponent };